<template>
  <div class="spl-adhocDrive-list-table">
    <table v-if="!isLoading">
      <thead>
        <tr class="spl-adhocDrive-table__head">
          <th class="spl-adhocDrive-table__head--checkbox">
            <form-checkbox
              :checked="allAdhocSelected"
              @checkboxChanged="checkAllAdhocs" />
          </th>
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index"
            @click="toggleSort(header.name)">
            <span
              v-if="findSort(sortedFields, header.name)"
              :class="findSort(sortedFields, header.name).direction"
              class="order-arrow" />
            {{ header.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(adhocDrive, adhocDriveIndex) in adhocDriveList" :key="'adhocDriveTable' + adhocDriveIndex">
          <td class="spl-parcel-table__field--checkbox">
            <form-checkbox
              :checked="adhocDrive.Is_Invoiced_To_Customer"
              @checkboxChanged="checkAdhoc(adhocDrive)" />
          </td>
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + adhocDriveIndex + '.' + fieldIndex"
            :class="{'spl-adhocDrive-table__field--number': isNumber(adhocDrive[field.name]),
                     'spl-adhocDrive-table__field--long': field.long,
                     'spl-adhocDrive-table__field--bold': field.bold}"
            @click="adhocDriveSelected(adhocDrive)">
            <span>
              {{ formatField(adhocDrive[field.name], field.type) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters } from 'vuex'
import { find, findIndex, isNumber, filter } from 'lodash'
import { AdhocDriveListItem } from '@/webApi/DataModels'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'Counter_Number', label: 'Counter Number', type: 'String' },
        { name: 'Customer_Name', label: 'Customer', type: 'String' },
        { name: 'Country_Name', label: 'Country', type: 'String' },
        { name: 'Provider_Name', label: 'Provider', type: 'String' },
        { name: 'Date_Of_Order', label: 'Date', type: 'Date' },
        { name: 'From_City', label: 'From City', type: 'String' },
        { name: 'To_City', label: 'To City', type: 'String' },
        { name: 'Description', label: 'Description', type: 'String' },
        { name: 'Number_Of_Parcels', label: 'Parcels', type: 'Number' },
        { name: 'Weight', label: 'Weight', type: 'Number.2' },
        { name: 'Cost_Coverage_By', label: 'Cost Coverage By', type: 'String' },
        { name: 'Agreed_Cost', label: 'Agreed Cost', type: 'Number.2' },
        { name: 'Agreed_Price', label: 'Agreed Price', type: 'Number.2' },
        { name: 'Currency_Name', label: 'Currency', type: 'String' },
        { name: 'Service_Leg_Name', label: 'Service Leg', type: 'String' },
        { name: 'AWB_Reference', label: 'AWB Number', type: 'String' },
        { name: 'Forwarder_Reference', label: 'Forwarder Reference', type: 'String' },
        { name: 'Comments', label: 'Comments', type: 'String' },
        { name: 'User_Name', label: 'User', type: 'String' }
      ],
      sortedFields: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('adhocDrive', ['adhocDriveList']),
    allAdhocSelected () {
      for (let i = 0; i < this.adhocDriveList.length; i++) {
        if (!this.adhocDriveList[i].Is_Invoiced_To_Customer) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    ...mapActions('adhocDrive', ['sortList']),
    toggleSort (field) {
      // Finds the sorted field in the array
      var sortedField:any = find(this.sortedFields, { field: field })
      if (sortedField) {
        // Switches to desc when asc already selected
        if (sortedField.direction === 'asc') {
          sortedField.direction = 'desc'
        } else {
          // removes the sorting when desc was selected
          this.sortedFields.splice(findIndex(this.sortedFields, { field: field }))
        }
      } else {
        // adds the field when not yet present
        this.sortedFields.push({ direction: 'asc', field: field })
      }
      this.sortData()
    },
    adhocDriveSelected (adhocDrive:AdhocDriveListItem) {
      this.$router.push('adhoc-drive-edit/'+ adhocDrive.Adhoc_Drive_ID)
    },
    checkAllAdhocs (checked) {
      for (let i = 0; i < this.adhocDriveList.length; i++) {
        const adhoc = this.adhocDriveList[i]
        adhoc.Is_Invoiced_To_Customer = checked
      }
      this.shoutSelectionChange()
    },
    shoutSelectionChange () {
      this.$forceUpdate()
      const selectedAdhocs = filter(this.adhocDriveList, 'Is_Invoiced_To_Customer')
      this.numSelectedParcels = selectedAdhocs.length
    },
    checkAdhoc (adhoc) {
      adhoc.Is_Invoiced_To_Customer = !adhoc.Is_Invoiced_To_Customer
      this.shoutSelectionChange()
    },
    // Sorting the data
    sortData () {
      // Sort fields and directions seperate for lodash orderBy method
      let sortFields = []
      let sortDirections = []
      // Create the sort fields
      for (let i = 0; i < this.sortedFields.length; i++) {
        const sortElement = this.sortedFields[i]
        sortFields.push(sortElement.field)
        sortDirections.push(sortElement.direction)
      }
      // Default sorting depending on grouping
      if (sortFields.length === 0) {
        sortFields = [constants.FILTER_NAMES.COUNTRY]
        sortDirections = ['asc']
      }
      // Use the lodash orderBy method for sorting
      this.sortList({ sortFields, sortDirections })
    },
    // Special formatting for fields
    formatField (field, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      } else if (type === 'Number.2') {
        return this.numberFormat(field, 2, false)
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    // find the right sort value for displaying arrows
    findSort (array, value) {
      return find(array, { field: value })
    },
    // including of helper since lodash not available in vue template
    isNumber (value) {
      return isNumber(value)
    }
  }

}
</script>

<style lang="scss">
  @import '../../../variables.scss';
  .spl-adhocDrive-list-table {
    margin: 0 70px;
    width: calc(100% - 138px);

    table {
      border-spacing: 0;
      table-layout: fixed;
      padding-bottom: 20px;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 2px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: center;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }
}
</style>
